import { render } from "./CallHistoryView.vue?vue&type=template&id=9119bc9c&scoped=true"
import script from "./CallHistoryView.vue?vue&type=script&lang=js"
export * from "./CallHistoryView.vue?vue&type=script&lang=js"

import "./CallHistoryView.vue?vue&type=style&index=0&id=9119bc9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9119bc9c"]])

export default __exports__